export const getCurrentIssueData = state => state?.currentIssue?.data || null
